export default {
    SAVE_PARAMS: 'SAVE_PARAMS',
    DELETE_PARAMS: 'DELETE_PARAMS',
    RESET_ALL_PARAMS: 'RESET_ALL_PARAMS',
};
